import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedSection from './components/FeaturedSection';
import LatestSection from './components/LatestSection';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import { faqList } from '@/mocks/faq';

export default function Home() {
  const faqSchemaData = {
    mainEntity: faqList.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <SchemaOrg type="Organization" />
      <SchemaOrg type="WebSite" />
      <SchemaOrg
        type="WebPage"
        data={{
          name: '91爆料网 - 首页',
          description: '91爆料网在线为你提供第一手社会热点与劲爆八卦，是真正的91网上吃瓜导航。每日实时曝料网红黑料、娱乐八卦、社会热点。',
          url: 'http://gm3pta.cn/',
        }}
      />
      <SchemaOrg type="FAQPage" data={faqSchemaData} />

      <Navbar />

      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedSection />
        <LatestSection />
        <CTASection />
        <FAQSection />
      </main>

      <Footer />
    </>
  );
}